import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import keyword1 from "../Images/keywrord1.png";
import keyword2 from "../Images/keyword2.png";
const Keywordresearch = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
      
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1 className="text-center m-3">
              Keyword Research: Discover what your audience is really searching
              for
            </h1>
            <div className="d-flex justify-content-center m-md-5 m-3">
              <div className="position-relative" style={{ width: "30vw" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your keywords"
                  style={{
                    borderRadius: "50px",
                    height: "3rem",
                  }}
                />
                <a
                  href="/pricing-plans"
                  className="btn position-absolute"
                  style={{
                    top: "50%",
                    right: "0.5rem",
                    transform: "translateY(-50%)",
                    borderRadius: "50px",
                    background: "rgb(175, 221, 255) 0%",
                    color: "rgb(0, 51, 102)",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0.3rem 1rem",
                  }}
                >
                  ANALYZE
                </a>
              </div>
            </div>
            <p>
              Seobix makes it easier, faster, and smarter. Whether you're
              running a blog, small business, or eCommerce store, Seobix gives
              you everything you need to find the right keywords and build
              content that ranks. What makes us different? Seobix combines three
              powerful keyword tools in one place:{" "}
              <b>Keyword Tool, Keyword Magic Tool, and Keyword Builder </b> —all
              designed to help you go beyond basic keyword searches and unlock
              real opportunities for growth.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={keyword1}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h2>Keyword Tool</h2>

            <p>
              With our Keyword Tool, you can quickly find out what your audience
              is actually searching for. Just enter a word or phrase, and Seobix
              will give you a list of high-potential keywords along with search
              volume, competition, long-tail keywords and trends. It's your
              first step to building content that connects.
            </p>

            <h2>Keyword Magic Tool</h2>

            <p>
              This tool helps you uncover long-tail and niche keywords that
              other tools might miss. The Keyword Magic Tool makes your research
              more specific and focused by suggesting related keywords,
              variations, and even questions people ask. It’s a great way to
              create content that’s relevant and ranks well—perfect for small
              businesses looking to compete big.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="mb-3"
                src={keyword2}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h2>Keyword Builder</h2>

            <p>
              Finding keywords is one thing. Organizing them into a working
              strategy is another. That’s where the Keyword Builder comes in. It
              helps you group, sort, and save keywords based on your topics or
              campaigns. Plan smarter, write better, and save time while doing
              it.
            </p>
       
            <h2>Start Growing with Smarter Keyword Research</h2>
            <p>
              No more jumping between tools. No more guessing what to write.
              Seobix brings everything under one roof to help you find,
              organize, and use the right keywords—all while supporting your
              structured data efforts for better visibility and ranking.
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Keywordresearch;
